/** CoStar.Api.SuiteDetail.TenantCompanyTenantRepContacts.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["LastNameAsc"] = 1] = "LastNameAsc";
    SortType[SortType["LastNameDsc"] = 2] = "LastNameDsc";
    SortType[SortType["CompanyAsc"] = 3] = "CompanyAsc";
    SortType[SortType["CompanyDsc"] = 4] = "CompanyDsc";
    SortType[SortType["JobTitleAsc"] = 5] = "JobTitleAsc";
    SortType[SortType["JobTitleDsc"] = 6] = "JobTitleDsc";
    SortType[SortType["PhoneNumberAsc"] = 7] = "PhoneNumberAsc";
    SortType[SortType["PhoneNumberDsc"] = 8] = "PhoneNumberDsc";
    SortType[SortType["MobilePhoneAsc"] = 9] = "MobilePhoneAsc";
    SortType[SortType["MobilePhoneDsc"] = 10] = "MobilePhoneDsc";
    SortType[SortType["TenantLocationsAsc"] = 11] = "TenantLocationsAsc";
    SortType[SortType["TenantLocationsDsc"] = 12] = "TenantLocationsDsc";
    SortType[SortType["TenantSfOccupiedAsc"] = 13] = "TenantSfOccupiedAsc";
    SortType[SortType["TenantSfOccupiedDsc"] = 14] = "TenantSfOccupiedDsc";
    SortType[SortType["HqCityAsc"] = 15] = "HqCityAsc";
    SortType[SortType["HqCityDsc"] = 16] = "HqCityDsc";
    SortType[SortType["HqStateAsc"] = 17] = "HqStateAsc";
    SortType[SortType["HqStateDsc"] = 18] = "HqStateDsc";
    SortType[SortType["HqCountryAsc"] = 19] = "HqCountryAsc";
    SortType[SortType["HqCountryDsc"] = 20] = "HqCountryDsc";
})(SortType || (SortType = {}));
